export default "__VITE_ASSET__Bv6Gha3W__"